'use strict';
export const Constants = Object.freeze({
  STATUS_CHANGE_MESSAGE: 'statusSuccessfullyUpdated',
});
